<template>
  <div class="grid-cell">
    <div v-bind:class="[hasMedia, post.network, hasComment, post.post_type, videoType, noAvatar]" class="post-wrapper" data-toggle="modal" data-target="#modal" v-on:click="openPostModal">
      <div class="post">

        <div v-if="hasMedia" class="media-module">
          <template v-if="isVideoPreview">
            <video class="media video" type="video/mp4" muted v-bind:src="videoUrl" alt="video" title="Video"></video>
            <button class="tb-btn tb-btn-contained on-image play-btn"><span class="icon icon-play"></span></button>
          </template>
          <template v-else-if="post.post_type === 'video'">
            <img class="media video" v-bind:src="photoUrl" alt="">
            <div v-if="post.videos[0].type === 'gif'" class="tb-btn tb-btn-contained on-image play-btn gif">gif</div>
            <button v-else class="tb-btn tb-btn-contained on-image play-btn"><span class="icon icon-play"></span></button>
          </template>
          <template v-else>
            <img class="media photo" v-bind:src="photoUrl" alt="">
          </template>
        </div>

        <div class="text-module">

          <div v-if="!isStories" v-bind:class="verified" class="meta-author clearfix">

            <span class="avatar" v-if="hasAvatar"><img v-bind:src="post.user_profile_image_url" alt="" class="user-img"></span>

            <template v-if="post.network === 'instagram'">
              <span v-if="post.user_name" class="handle">@<span v-html="post.user_name"></span></span>
              <span v-else class="handle">Instagram user</span>
            </template>

            <template v-if="post.network === 'share-it'">
              <span v-if="post.user_name" class="handle"><span v-html="post.user_name"></span></span>
            </template>

            <template v-if="post.network === 'reddit'">
              <span v-if="post.service_meta.subreddit" class="subreddit">in r/<span v-html="post.service_meta.subreddit"></span></span>
              <span class="handle">by u/<span v-html="post.user_real_name"></span></span>
            </template>

            <template v-if="post.network !== 'instagram' && post.network !== 'reddit'">
              <span class="author" v-html="post.user_real_name"></span>
              <span v-if="post.network === 'twitter' || post.network === 'tiktok' || post.network === 'threads'" class="handle">@<span v-html="post.user_name"></span></span>
              <span v-else-if="isChat" class="handle"><span v-html="post.user_name"></span></span>
            </template>

          </div>

          <template v-if="!hasMedia">
            <div class="message">
              <div class="post-title" v-if="!isComment && post.title" v-html="post.title"></div>
              <div v-if="isChat" class="post-text" v-html="postHtml"></div>
              <div v-else class="post-text" v-html="post.text"></div>
            </div>
          </template>
        </div>

        <div class="origin-flag" v-bind:class="networkIconClass"></div>
      </div>

    </div>
  </div>
</template>

<script>
const imagesLoaded = require('imagesloaded');
const PostUtils = require('@tagboard/helpers/post-utils');
const MediaProxy = require('@tagboard/helpers/media-proxy');

export default {
  props: ['post'],
  data() {
    return {
      proxyAttempt: false,
    };
  },
  mounted() {
    const $post = $(this.$el);
    const img = imagesLoaded($post);
    const self = this;

    img.on('progress', (instance, image) => {
      if (!image.isLoaded) {
        if (image.img.className === 'user-img') {
          image.img.src = 'https://static.tagboard.com/public/img/profile_placeholder.jpg'; // eslint-disable-line no-param-reassign
        } else if (!self.proxyAttempt && MediaProxy.usingNetwork(self.post.network)) {
          self.proxyAttempt = true;
        } else {
          $post.remove();
        }
      }
    });
  },
  methods: {
    openPostModal() {
      this.$store.dispatch('setModalPost', this.post);
      this.$store.dispatch('toggleModal', this.post);
    },
  },
  computed: {
    hasMedia() {
      const hasPhotos = this.post.photos && this.post.photos.length;
      const hasVideos = this.post.videos && this.post.videos.length;
      if (hasPhotos || hasVideos) {
        return 'has-media';
      }

      return '';
    },
    isStories() {
      return ['snapchat', 'instagram-stories'].includes(this.post.network);
    },
    isChat() {
      return this.post.post_type === 'chat';
    },
    isComment() {
      return !!(this.post.tgb_meta && this.post.tgb_meta.isComment);
    },
    hasComment() {
      if (this.isComment) {
        return 'has-comment';
      }

      return '';
    },
    hasAvatar() {
      switch (this.post.network) {
        case 'instagram':
        case 'reddit':
        case 'share-it':
          return false;
        case 'facebook':
          if (this.isComment) {
            // Facebook Comments don't display avatars
            return false;
          }

          return true;

        default:
          return true;
      }
    },
    noAvatar() {
      let hasAvatar = true;

      switch (this.post.network) {
        case 'instagram':
        case 'reddit':
        case 'share-it':
          // Reddit doesn't display avatars
          hasAvatar = false;
          break;
        case 'facebook':
          if (this.isComment) {
            // Facebook Comments don't display avatars
            hasAvatar = false;
          }

          break;
        default:
          break;
      }

      return hasAvatar ? '' : 'no-avatar';
    },
    networkIconClass() {
      if (!this.post.network) {
        return '';
      }

      if (this.post.network === 'instagram-stories') {
        return 'icon icon-instagram';
      }

      if (this.post.network === 'twitter') {
        return 'icon icon-twitterx';
      }

      return `icon icon-${this.post.network}`;
    },
    verified() {
      return {
        verified: this.post.service_meta && this.post.service_meta.user_verified,
        gov: this.post.service_meta && this.post.service_meta.user_verified && this.post.service_meta.verified_type === 'government',
        org: this.post.service_meta && this.post.service_meta.user_verified && this.post.service_meta.verified_type === 'business',
      };
    },
    photoUrl() {
      if (this.post.post_type === 'photo' && this.post.photos?.length) {
        let url = this.post.photos[0].m;
        if (this.post.network === 'facebook') {
          url = this.post.photos[0].l || this.post.photos[0].m;
        } else if (this.post.network === 'instagram') {
          url = PostUtils.instagramMediaUrl(this.post, 'm');
        }

        return this.proxyAttempt ? MediaProxy.genUrl(url) : url;
      }

      if (this.post.videos && this.post.videos.length) {
        let url = this.post.videos[0].p;
        if (this.post.network === 'youtube') {
          url = this.post.videos[0].t;
        } else if (this.post.network === 'instagram') {
          url = PostUtils.instagramMediaUrl(this.post, 'p');
        }

        return this.proxyAttempt ? MediaProxy.genUrl(url) : url;
      }

      return '';
    },
    videoType() {
      return this.post?.videos?.[0]?.type || '';
    },
    videoUrl() {
      const isVideoType = this.post.post_type === 'video';
      const hasVideos = this.post.videos && this.post.videos.length;
      if (isVideoType && hasVideos) {
        return this.post.videos[0].m;
      }

      return undefined;
    },
    isVideoPreview() {
      const isVideoPost = this.post.post_type === 'video';
      const hasVideoUrl = !!this.videoUrl;
      const hasNoVideoPosterUrl = !this.photoUrl;
      const isMp4 = this.videoType === 'mp4';
      return isVideoPost && hasVideoUrl && hasNoVideoPosterUrl && isMp4;
    },

    postHtml() {
      return this.post.html || this.post.text;
    },
  },
};
</script>
